import React, { useEffect, useState } from "react";
import {
  InstantSearch,
  Hits,
  Configure,
  useInstantSearch,
} from "react-instantsearch";
import algoliasearch from "algoliasearch/lite";
import "./s.css";
import "instantsearch.css/themes/reset.css";
import { useLocation, useNavigate } from "react-router-dom";
import { auth, db } from "../../Admin/Config/Config";
import SearchErrorToast from "./HandlingErrors/SearchErrorToast";
import CustomRefinementList from "./CustomRefinements/CustomRefinementList";
import { doc, getDoc } from "firebase/firestore";
import Pagination from "./Pagination/Pagination";
import { useToast } from "../../Toast.jsx/Toast";
import { useCart } from "../Product/CartContext";
import { onAuthStateChanged } from "firebase/auth";
import AlgoliaPrice from "./AlogilaSearchPrice/AlgoliaPrice";
const searchClient = algoliasearch(
  "5G9MHFNZC5",
  "2e28960245c248137aaf095e4110be76"
);

const SearchPage = () => {
  const [term, setTerm] = useState("");
  const location = useLocation();
  const [triggerCat, setTriggerCat] = useState('');

  // ====================================== Query params ====================================== //
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const queryParam = params.get("query");
    const cat = params.get("f");
    if (queryParam) {
      setTerm(queryParam);
    }
    if (cat) {
      setTriggerCat(cat ? cat : '');
    } else {
      setTriggerCat('');
    }
  }, [location]);

  // Ensure page loads from the top when this component mounts
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, []);

  return (
    <div>
      {console.log("Triggered Category:", triggerCat)}
      <InstantSearch searchClient={searchClient} indexName="products">
        <Configure query={term} />
        <div className="py-4 px-4 lg:px-6">
          <button
            className="md:hidden bg-gradient-to-r from-slate-700 to-slate-800 hover:from-slate-800 hover:to-slate-900 text-white px-6 py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 font-medium"
            onClick={() => {
              const panel = document.getElementById("filterPanel");
              const overlay = document.getElementById("overlay");
              panel.classList.toggle("translate-x-0");
              overlay.classList.toggle("hidden");
            }}
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.414A1 1 0 013 6.707V4z"
              />
            </svg>
            Filters
          </button>
        </div>

        <div className="flex flex-col md:flex-row min-h-screen bg-white">
          <>
            {/* Background overlay */}
            <div
              id="overlay"
              className="fixed inset-0 bg-black bg-opacity-60 z-40 hidden md:hidden transition-opacity duration-300"
              onClick={() => {
                const panel = document.getElementById("filterPanel");
                const overlay = document.getElementById("overlay");
                panel.classList.toggle("translate-x-0");
                overlay.classList.toggle("hidden");
              }}
            />

            {/* Modern Filter Panel */}
            <aside
              id="filterPanel"
              className="filter-panel bg-white md:bg-white/95 md:backdrop-blur-xl border-r border-slate-200/50 
               p-6 fixed md:relative top-0 left-0 
               w-full md:w-80 lg:w-96 
               h-screen md:h-screen
               transform -translate-x-full md:translate-x-0 
               transition-all duration-500 ease-out 
               z-50 md:z-30 
               overflow-y-auto"
              style={{ zIndex: 60 }}
            >
              {/* Header */}
              <div className="flex items-center justify-between mb-8 pb-4 border-b border-slate-200">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-gradient-to-br from-slate-600 to-slate-700 rounded-xl flex items-center justify-center shadow-lg">
                    <svg
                      className="w-5 h-5 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.414A1 1 0 013 6.707V4z"
                      />
                    </svg>
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-slate-800">
                      Filters
                    </h2>
                    <p className="text-sm text-slate-500">Refine your search</p>
                  </div>
                </div>
                <button
                  className="md:hidden w-8 h-8 bg-slate-100 hover:bg-slate-200 rounded-lg flex items-center justify-center transition-colors duration-200"
                  onClick={() => {
                    const panel = document.getElementById("filterPanel");
                    const overlay = document.getElementById("overlay");
                    panel.classList.toggle("translate-x-0");
                    overlay.classList.toggle("hidden");
                  }}
                >
                  <svg
                    className="w-5 h-5 text-slate-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              {/* Filter Sections */}
              <div className="space-y-6">
                <div className="filter-section">
                  <CustomRefinementList attribute="brand" name="Brands" />
                </div>
                <div className="filter-section">
                  <CustomRefinementList
                    attribute="category"
                    name="Categories"
                  />
                </div>
              </div>
            </aside>
          </>

          <main className="flex-grow md:w-[calc(100%-20rem)] lg:w-[calc(100%-24rem)] p-4 lg:p-6 overflow-y-auto h-screen">
            <Configure filters="offer_price > 0" />
            <Configure filters="rating > 0" />
            <Configure filters={`status:"${true}"`} />

            {triggerCat && (
              <Configure
                filters={`category:"${triggerCat}" AND status:${true}`}
              />
            )}

            <SearchErrorToast />
            <NoResultsBoundary fallback={<NoResults />}>
              <Configure hitsPerPage={20} />
              <Hits hitComponent={Hit} />
            </NoResultsBoundary>
            <div className="flex  justify-center items-center">
              <Pagination />
            </div>
          </main>
        </div>

        <div className="flex py-12 justify-center items-center"></div>
      </InstantSearch>
    </div>
  );
};

const Hit = ({ hit }) => {
  const navigate = useNavigate();
  // ================================ Navigate to view page ================================ //
  const handleDivClick = async (id) => {
    navigate(`/view?query=${encodeURIComponent(id)}`);
  };

  // ================================ Navigate to view page ================================ //

  const { addToCart } = useCart();
  const [uid, setUid] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUid(user.uid);
        const userRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          setUserDetails(userData);
        }
      } else {
        setUid(null);
      }
    });
  }, [uid]);

  const [loading, setLoading] = useState({ state: false, id: "" });
  const { showWarning } = useToast();
  const handleAddToCart = async (e, product) => {
    e.stopPropagation();
    if (loading) { };
    if (product.stock < 1) {
      showWarning("Out of stock");
      return;
    }
    const quantity = getQuantity(product.objectID)
    if (!auth.currentUser) {
      setLoading({ state: true, id: product.objectID });
      const docSnapshot = await getDoc(
        doc(db, "products", product.objectID)
      );
      if (docSnapshot.exists()) {
        addToCart("", {
          id: product.objectID,
          ...docSnapshot.data(),
          cart_quantity: quantity
        });
        setLoading({ state: false, id: "" });
      } else {
        alert("Something went wrong.. Please try again later.");
        setLoading({ state: false, id: "" });
      }
    } else {
      setLoading({ state: true, id: product.objectID });
      const docSnapshot = await getDoc(
        doc(db, "products", product.objectID)
      );
      if (docSnapshot.exists()) {
        addToCart(auth.currentUser.uid, {
          id: product.objectID,
          ...docSnapshot.data(),
          cart_quantity: quantity
        });
        setLoading({ state: false, id: "" });
      } else {
        alert("Something went wrong.. Please try again later.");
        setLoading({ state: false, id: "" });
      }
    }
  };

  const [isImageLoading, setIsImageLoading] = useState(true);

  const handleImageLoad = () => {
    setIsImageLoading(false);
  };

  const [quantities, setQuantities] = useState({});
  const getQuantity = (productId) => quantities[productId] || 1;
  const updateQuantity = (productId, newQuantity) => {
    if (newQuantity >= 1 && newQuantity <= 99) {
      setQuantities(prev => ({
        ...prev,
        [productId]: newQuantity
      }));
    }
  };
  return (
    <div className="p-1 sm:p-1.5">
      <div
        onClick={() => {
          handleDivClick(hit.objectID);
        }}
        key={hit.objectID}
        className="group relative bg-white border border-red-500 rounded-xl sm:rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 hover:border-red-600 flex flex-col justify-between"
      >
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-50/50 via-transparent to-slate-100/30 rounded-xl sm:rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>

        {/* Product Image Portion (White) */}
        <div className="relative w-full h-24 sm:h-32 md:h-36 p-2 bg-white flex justify-center items-center overflow-hidden">
          {isImageLoading && (
            <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-slate-200 via-slate-300 to-slate-200 animate-pulse rounded-xl"></div>
          )}
          {hit.product_code_sku && (
            <div className="absolute top-1.5 right-1.5 z-20 flex items-center bg-white/95 backdrop-blur-md px-1.5 py-0.5 rounded-md shadow-xs border border-slate-300/80 transition-all duration-300 group-hover:border-red-200 group-hover:bg-red-50/90">
              <span className="text-[10px] sm:text-xs font-bold text-slate-700 font-mono leading-none group-hover:text-red-600 transition-colors duration-200">
                {hit?.product_code_sku || "N/A"}
              </span>
            </div>
          )}

          <img
            src={hit.thumb_url}
            alt={hit.product_name}
            className={`w-full h-full object-contain transition-all duration-500 group-hover:scale-110 ${isImageLoading ? "opacity-0" : "opacity-100"
              }`}
            onLoad={handleImageLoad}
          />
        </div>

        {/* Product Info Portion (Light Beige Two-Tone) */}
        <div className="relative z-10 p-2.5 sm:p-4 bg-[#faf6f0] border-t border-amber-100/70 flex-1 flex flex-col justify-between space-y-1.5 sm:space-y-2">
          <div>
            {/* Product Name */}
            <h3 className="text-xs sm:text-sm font-semibold text-slate-700 leading-tight group-hover:text-slate-900 transition-colors duration-300 line-clamp-2 min-h-[1.8rem] sm:min-h-[2.5rem]">
              {hit.product_name.length > 45
                ? `${hit.product_name.slice(0, 45)}...`
                : hit.product_name}
            </h3>

            {/* Brand & Price in same row */}
            <div className="flex items-center justify-between gap-1 mt-1 min-h-[1.5rem]">
              {hit.brand ? (
                <div className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-red-600 bg-red-50 border border-red-100 rounded px-1.5 py-0.5 inline-block w-max truncate">
                  {hit.brand}
                </div>
              ) : (
                <div />
              )}
              <AlgoliaPrice product={{ id: hit.objectID, ...hit }} userDetails={userDetails} priceOnly={true} />
            </div>
          </div>

            {/* Quantity & Cart Section */}
            <div>
              {hit.measure_unit && (
                <div className="text-[10px] sm:text-xs font-semibold text-slate-600 mb-1 capitalize">
                  {hit.measure_unit}
                </div>
              )}
              <div className="flex items-center justify-between gap-2">

                {/* Quantity Selector */}
                <div className="flex items-center bg-white border border-slate-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 w-full max-w-[180px]">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      updateQuantity(hit.objectID, getQuantity(hit.objectID) - 1);
                    }}
                    className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 text-slate-500 hover:text-slate-700 hover:bg-slate-50 transition-all duration-200 rounded-l-lg group"
                    disabled={getQuantity(hit.objectID) <= 1}
                  >
                    <svg
                      className="w-3 h-3 sm:w-4 sm:h-4 transition-transform group-active:scale-90"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M20 12H4" />
                    </svg>
                  </button>

                  <div className="flex-1 flex items-center justify-center h-8 sm:h-10 text-slate-800 font-semibold text-sm sm:text-base bg-slate-50 border-l border-r border-slate-200">
                    {getQuantity(hit.objectID)}
                  </div>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      updateQuantity(hit.objectID, getQuantity(hit.objectID) + 1);
                    }}
                    className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 text-slate-500 hover:text-slate-700 hover:bg-slate-50 transition-all duration-200 rounded-r-lg group"
                    disabled={getQuantity(hit.objectID) >= 99}
                  >
                    <svg
                      className="w-3 h-3 sm:w-4 sm:h-4 transition-transform group-active:scale-90"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </button>
                </div>
                {/* Add to Cart Button */}
                <button
                  onClick={(e) => handleAddToCart(e, hit)}
                  className="relative flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 bg-gradient-to-r from-slate-700 to-slate-800 hover:from-slate-800 hover:to-slate-900 text-white rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-slate-400/30 active:scale-95 group/btn"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4 sm:w-4 sm:h-4 transition-transform duration-300 group-hover/btn:scale-110 group-hover/btn:rotate-12"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m0 0H17M9 19.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM20 19.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
                    />
                  </svg>

                  {/* Tooltip */}
                  <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 bg-slate-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap opacity-0 group-hover/btn:opacity-100 transition-opacity duration-200 pointer-events-none z-20">
                    Add to Cart
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-2 border-transparent border-t-slate-800"></div>
                  </div>
                </button>
              </div>
            </div>

            {/* Get Quote button (if product has no price) */}
            <AlgoliaPrice product={{ id: hit.objectID, ...hit }} userDetails={userDetails} quoteOnly={true} />
        </div>
      </div>
    </div>
  );
};
function NoResultsBoundary({ children, fallback, onNoResults }) {
  const { results } = useInstantSearch();

  if (!results.__isArtificial && results.nbHits === 0) {
    return (
      <>
        {fallback}
        <div hidden>{children}</div>
      </>
    );
  }
  return children;
}

function NoResults() {
  const { indexUiState } = useInstantSearch();

  return (
    <div>
      <p>
        No results for <q>{indexUiState.configure.query}</q>.
      </p>
    </div>
  );
}


export default SearchPage;
